import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const VideoItem = ({ data, isMobile }) => (
  <>
    {data ?
      <a href={data.url || '/'} className={cx('title', 'titleLink', 'item', isMobile && 'center')}>
        {data.imageUrl ?
          <img
            className={cx('img', isMobile && 'imgMob')}
            id={data.title}
            src={data.imageUrl}
            loading="lazy"
            alt=""
          />
        : <iframe src={data.url} frameBorder="0" allowFullScreen title={data.title} />}
        <div className={cx('title', 'titleLink')}>{(data || {}).title || ''}</div>
      </a>
    : null}
  </>
);

VideoItem.defaultProps = {
  data: {},
};

VideoItem.propTypes = {
  data: PropTypes.shape({
    imageUrl: PropTypes.string,
    url: PropTypes.string,
    title: PropTypes.string,
  }),
  isMobile: PropTypes.bool,
};

export default VideoItem;
